<template>
  <div class="freight-detail">
    <div class="freight-detail-table">
      <vxe-toolbar size="mini" v-if="!disabled">
        <template v-slot:buttons>
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新建货物</el-button
          >
          <el-button @click="editRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >编辑货物</el-button
          >
          <el-button @click="importHandler" size="small" type="primary" class="vxe-btn-primary"
            >导入</el-button
          >
          <el-button @click="deleteRowHandler" size="small" type="danger" class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="freightDetailRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :valid-config="{ autoPos: true, message: 'inline' }"
        :checkbox-config="{ checkMethod: this.activeCheckMethod }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        height="300"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in chartColumns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item?.field == 'qtyUnit'">{{ getUnitName('qty', row[item.field]) }}</span>
            <span v-else-if="item?.field == 'grossWeightUnit'">{{
              getUnitName('gross', row[item.field])
            }}</span>
            <span v-else-if="item?.field == 'volumeUnit'">{{
              getUnitName('volume', row[item.field])
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
    <EditFreightDialog ref="dialogRef" @confirmHandler="confirmHandler"></EditFreightDialog>
    <SiruiUpload
      ref="siruiUpload"
      :isShowDownTemplateBtn="true"
      @ossSuccess="importSuccess"
      :action="IMPORT_URL"
      source="intermodality"
      :data="importData"
    />
  </div>
</template>

<script>
  import { chartColumns } from './columns.js';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import EditFreightDialog from '@/pages/intermodality/common/charts/freightDetailChart/editFreightDialog';
  import SiruiUpload from '@/components/SiruiUpload';
  // import BASEAPI from '@/api/dataBase.js';
  export default {
    name: 'FreightDetailChart',
    mixins: [IntermodalityCommonMixin],
    components: {
      EditFreightDialog,
      SiruiUpload,
    },
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectedList: [],
        tableData: [],
        chartColumns,
        qtyUnitList: [],
        volumeUnitList: [],
        grossWeightUnitList: [],
        IMPORT_URL: '/sales/mto/contract/importCargo',
      };
    },
    methods: {
      activeCheckMethod() {
        //是否可以编辑
        return true;
      },
      clearSelection() {
        this.$refs.freightDetailRef.clearCheckboxRow();
        this.selectedList = [];
      },
      importHandler() {
        this.$refs.siruiUpload.openDialog(true, '095');
      },
      async importSuccess(response) {
        if (response.msg && response.msg.includes('导入失败')) {
          window.open(response.data);
          return;
        }
        let list = response.data;
        await this.$refs.freightDetailRef.insertAt(list, -1);
        this.tableData = this.getTableData();
        this.$emit('handleChartChange', 'cargo', this.tableData);
      },

      //新插入一行或者编辑
      async confirmHandler(data, isEdit) {
        if (isEdit) {
          const list = this.$refs.freightDetailRef?.getTableData()?.fullData;
          const index = list.findIndex((item) => item._XID == data.xid);
          delete data.xid;
          console.log('edit', index, list);
          list.splice(index, 1, data);
          this.tableData = list;
        } else {
          await this.insertEvent(data, 0);
          this.tableData = this.getTableData();
        }

        this.$emit('handleChartChange', 'cargo', this.tableData);
      },
      // 新增行
      async newRowHandler() {
        this.clearSelection();
        this.$refs.dialogRef.openModal();
      },
      editRowHandler() {
        if (this.selectedList.length && this.selectedList.length == 1) {
          let item = { ...this.selectedList[0] };
          this.$refs.dialogRef.openModal(item);
          this.clearSelection();
        } else {
          this.$message.error('请勾选一条数据进行编辑');
        }
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.freightDetailRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          // await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      deleteRowHandler() {
        // if (!this.selectedList.length || this.selectedList.length != 1) {
        //   this.$message.error('请勾选一条数据进行删除');
        //   return;
        // }
        if (this.selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('billDetail.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction('删除数据', '是否删除所选数据？')
          .then(() => {
            this.$refs.freightDetailRef.removeSelecteds();
            this.tableData = this.getTableData();
            this.$emit('handleChartChange', 'cargo', this.tableData);
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('billDetail.message.cancelled'),
            });
          });
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectedList = selection;
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        // if (field === 'currencyCode') {
        //   row['currencyName'] = this.currencyList?.find(
        //     (item) => item.value == row['currencyCode']
        //   )?.label;
        // } else if (field === 'expenseType') {
        //   row['expenseTypeLabel'] = this.expenseType?.find(
        //     (item) => item.value == row[field]
        //   )?.label;
        // } else if (field === 'originalAmount') {
        //   row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2);
        // }
      },
      async closeEditTableHandler() {
        console.log('关闭');
        // const $table = this.$refs.settleAccountsRef;
        // const errMap = await $table.validate().catch((errMap) => errMap);
        // if (errMap) {
        //   this.$message.error('请检查数据再提交');
        // } else {
        //   // 派发事件
        //   this.$emit('closeEditTableHandler', this.getTableData());
        //   await $table.clearActived();
        // }
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.freightDetailRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
    },
    computed: {
      // expenseType() {
      //   return this.dictListMap.expenseType;
      // },
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          belongTenantCode: this.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.access_token,
        };
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {},
  };
</script>

<style lang="scss" scoped>
  .freight-detail {
    background: #fff;

    .freight-detail-table {
      padding: 10px;
      box-sizing: border-box;
    }
  }
</style>
